/**
 * What the error banner says when a Soteria turn fails.
 *
 * The hook throws `HTTP 422` for any status it has no sentence for, and a
 * dropped connection reaches the catch as the browser's own `TypeError`
 * ("Failed to fetch" in Chrome, "Load failed" in Safari). Both were put in the
 * banner verbatim, so an advisor read a status code or a browser internal as
 * Soteria's reply. Sentences the hook wrote itself pass through untouched.
 */
const GENERIC =
  "Soteria couldn't take that question just now. Please try again in a moment.";

export function describeTurnError(err: unknown): string {
  if (!(err instanceof Error)) return GENERIC;
  const message = err.message.trim();

  const status = /^HTTP (\d{3})$/.exec(message)?.[1];
  if (status) {
    if (status === '413' || status === '422') {
      return 'Soteria could not take that message. It may be too long or contain something it cannot read.';
    }
    if (status === '403') {
      return "You don't have access to Soteria for this account.";
    }
    return GENERIC;
  }

  if (
    err instanceof TypeError ||
    /failed to fetch|load failed|networkerror/i.test(message)
  ) {
    return "Can't reach Soteria. Check your connection and try again.";
  }

  return message || GENERIC;
}
